import {useMemo} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {getPromotionTypeName} from "../helpers/PromotionType";
import {useAmplitudePromotionViewportTracking} from "../hooks/use_amplitude_promotion_viewport_tracking";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../tracking/get_amplitude_offer_page_promotion_tracking_context";
import {PromotionDetail} from "../types/PromotionDetail";

interface IProps {
    promotion: PromotionDetail;
    offerId?: number;
    propertyId?: number;
}

export const Promotion = (props: IProps) => {
    const {promotion, offerId, propertyId} = props;

    const trackingContext = useMemo(() => {
        if (!offerId) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId,
            propertyId,
            creativeSlot: "promotion_box"
        });
    }, [offerId, propertyId, promotion]);

    const {elementId} = useAmplitudePromotionViewportTracking({
        trackingContext,
        elementId: promotion.id.toString(),
        disabled: !offerId
    });

    return (
        <li className={promotionItemStyle} data-id={elementId}>
            <Text as="p" variant="info_txt_1" strong className={promotionBadgeStyle}>
                {getPromotionTypeName(promotion.type)}
            </Text>

            <Text as="p" variant="headline_6" className={promotionNameStyle}>
                {promotion.name}
            </Text>

            {promotion.description && (
                <Text as="p" variant="body_copy_2" className={promotionDescriptionStyle}>
                    {promotion.description}
                </Text>
            )}
        </li>
    );
};

const promotionItemStyle = css({
    "&:not(:last-of-type)": {
        mb: 4
    }
});

const promotionBadgeStyle = css({
    display: "inline-flex",
    backgroundColor: "color-mix(in srgb, var(--colors-highlight) 30%, transparent)",
    px: 1,
    py: 0.5,
    m: 0,
    mb: 2
});

const promotionNameStyle = css({
    m: 0,
    mb: 1
});

const promotionDescriptionStyle = css({
    mb: 2
});
import {useMemo} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {getPromotionTypeName} from "../helpers/PromotionType";
import {useAmplitudePromotionViewportTracking} from "../hooks/use_amplitude_promotion_viewport_tracking";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../tracking/get_amplitude_offer_page_promotion_tracking_context";
import {PromotionDetail} from "../types/PromotionDetail";

interface IProps {
    promotion: PromotionDetail;
    offerId?: number;
    propertyId?: number;
}

export const Promotion = (props: IProps) => {
    const {promotion, offerId, propertyId} = props;

    const trackingContext = useMemo(() => {
        if (!offerId) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId,
            propertyId,
            creativeSlot: "promotion_box"
        });
    }, [offerId, propertyId, promotion]);

    const {elementId} = useAmplitudePromotionViewportTracking({
        trackingContext,
        elementId: promotion.id.toString(),
        disabled: !offerId
    });

    return (
        <li className={promotionItemStyle} data-id={elementId}>
            <Text as="p" variant="info_txt_1" strong className={promotionBadgeStyle}>
                {getPromotionTypeName(promotion.type)}
            </Text>

            <Text as="p" variant="headline_6" className={promotionNameStyle}>
                {promotion.name}
            </Text>

            {promotion.description && (
                <Text as="p" variant="body_copy_2" className={promotionDescriptionStyle}>
                    {promotion.description}
                </Text>
            )}
        </li>
    );
};

const promotionItemStyle = css({
    "&:not(:last-of-type)": {
        mb: 4
    }
});

const promotionBadgeStyle = css({
    display: "inline-flex",
    backgroundColor: "color-mix(in srgb, var(--colors-highlight) 30%, transparent)",
    px: 1,
    py: 0.5,
    m: 0,
    mb: 2
});

const promotionNameStyle = css({
    m: 0,
    mb: 1
});

const promotionDescriptionStyle = css({
    mb: 2
});
